import * as auth from './auth'
import * as common from './common'

export const namespaces = {
  common,
  auth
}
